// src/components/LanguageSwitcher.js
import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiGlobe, FiChevronDown } from "react-icons/fi";
import api from "../services/api";

const languages = [
  { code: "en", name: "English", short: "EN" },
  { code: "fr", name: "Français", short: "FR" },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = async (lng) => {
    const normalized = lng === "fr" ? "fr" : "en";
    i18n.changeLanguage(lng);
    localStorage.setItem("chafadi-lang", normalized);
    const token = localStorage.getItem("chafadi-token");
    if (token) {
      try {
        await api.patch("/me/language/", { language: normalized });
      } catch (_) {}
    }
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[0];

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 h-10 px-4 rounded-full bg-white border border-component-border hover:border-chafadi-primary transition-all group"
      >
        <FiGlobe className="text-theme-muted group-hover:text-chafadi-primary transition-colors" />
        <span className="text-[10px] font-black text-theme-text uppercase tracking-widest">{currentLanguage.short}</span>
        <FiChevronDown className={`text-theme-muted transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-3 w-48 bg-white rounded-3xl border border-component-border shadow-2xl p-2 z-[1000] animate-zoom-in">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`w-full flex items-center justify-between px-6 py-3 rounded-2xl text-left transition-all ${
                i18n.language === lang.code 
                  ? "bg-chafadi-primary/5 text-chafadi-primary" 
                  : "text-theme-muted hover:bg-gray-50 hover:text-theme-text"
              }`}
            >
              <span className="text-xs font-black uppercase tracking-widest">{lang.name}</span>
              {i18n.language === lang.code && (
                <div className="w-1.5 h-1.5 bg-chafadi-primary rounded-full shadow-lg shadow-orange-500/50" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
